import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { enableSentry } from 'src/main';

@Component({
  selector: 'app-cookie-consent',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatDialogModule],
  templateUrl: './cookie-consent.component.html',
  styleUrl: './cookie-consent.component.scss',
})
export class CookieConsentComponent {
  constructor(public dialogRef: MatDialogRef<CookieConsentComponent>) {}

  accept(): void {
    localStorage.setItem('cookieConsent', 'true');
    localStorage.setItem('allowSentry', 'true');
    enableSentry();
    this.dialogRef.close();
  }

  necessaryAccept(): void {
    const oldAllowSentry = localStorage.getItem('allowSentry');
    localStorage.setItem('cookieConsent', 'true');
    localStorage.setItem('allowSentry', 'false');
    this.dialogRef.close();
    if(oldAllowSentry == 'true') {
      window.location.reload();
    }
  }
}
